import React from "react";
import { ReactComponent as CheckIcon } from "../../../../assets/icons/CheckLogo.svg";


export default function PreChecksGrid({ items }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items?.map((it, idx) => (
                <div key={idx} className={`p-4 rounded-lg ${it.state === "pass" ? "bg-green-50" : "bg-gray-50"}`}>
                    <div className="flex items-center justify-between mb-2">
                        <span className={`font-medium ${it.state === "pass" ? "text-green-900" : "text-gray-900"}`}>{it.title}</span>
                        {it.state === "pass" ? <CheckIcon /> : null}
                    </div>
                    <p className={`text-sm ${it.state === "pass" ? "text-green-700" : "text-gray-600"}`}>{it.text}</p>
                </div>
            ))}
        </div>
    );
}